// src/config.js
export const API_BASE = process.env.REACT_APP_API_BASE || "https://mediapi.keycodehms.com/api";




//https://api.keycodehms.com/api
// http://localhost:5097/api


//https://api.kamlahms.in/api

//https://apiumeed.keycodehms.com/api



//https://mediapi.keycodehms.com/api